import WebsiteComponent from "./components/WebsiteComponent";
import { websites } from "./websites";

export function Web() {
    return <div style={{ padding: "0px 32px" }}>
        <h1 style={{ marginBottom: "32px" }}>List of small web tools and websites</h1>
        <div className="website-list">
            {websites.map(website => (
                <div className="website-list-item" key={website.title}>
                    <WebsiteComponent website={website} />
                </div>
            ))}
        </div>
    </div>
}